import { render } from "./EditPupilForm.vue?vue&type=template&id=e7581e44"
import script from "./EditPupilForm.vue?vue&type=script&lang=js"
export * from "./EditPupilForm.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/volume-nbg1-3/html/musikalienverleih/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__